import React from "react";
import { PropTypes } from "prop-types";
import { useIntl } from "react-intl";

const LocationDetails = (props) => {
  const { latitude, longitude, address, err } = props;
  const intl = useIntl();

  return err ? (
    <div className="alert alert-danger" role="alert">
      <strong>Error!</strong>
      {err}
    </div>
  ) : latitude ? (
    <div className="alert alert-success" role="alert">
      <strong>
        {intl.formatMessage({
          id: "app.forms.location.locationSuccessLabel",
        })}
      </strong>
      <br />
      {intl.formatMessage({ id: "app.forms.location.address" })}
      <strong style={{ padding: "0 10px" }}>{address}</strong>
      <br />
      {intl.formatMessage({ id: "app.forms.location.latitude" })}
      <strong style={{ padding: "0 10px" }}>{latitude}</strong>
      <br />
      {intl.formatMessage({
        id: "app.forms.location.longitude",
      })}
      <strong style={{ padding: "0 10px" }}>{longitude}</strong>
    </div>
  ) : null;
};

LocationDetails.propTypes = {
  longitude: PropTypes.number,
  latitude: PropTypes.number,
  err: PropTypes.string,
  address: PropTypes.string,
};

export default LocationDetails;
